export default {
    state: () => ({
        medicalInsurance: [
            {
                name: "",
                image: "/Logo.svg",
            },
             {
                name: "",
                image: "/Logo.svg",
            },
              {
                name: "",
                image: "/Logo.svg",
            },
             {
                name: "",
                image: "/Logo.svg",
            },
             {
                name: "",
                image: "/Logo.svg",
            },
              {
                name: "",
                image: "/Logo.svg",
            },
             {
                name: "",
                image: "/Logo.svg",
            },
             {
                name: "",
                image: "/Logo.svg",
            },
             {
                name: "",
                image: "/Logo.svg",
            },
        ]
    }),
    getters: {
        getMedicalInsurance: (state) => state.medicalInsurance,
    },
    actions: {},
    mutations: {},
    namespaced: true,
}